import { Component, Inject, OnInit } from '@angular/core';
import { CloseConfirmComponent } from '../../close-confirm/close-confirm.component';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';
import { StreamEventComponent } from '../stream-event.component';
import { formatDate } from '@angular/common';
import * as moment from 'moment';

@Component({
  selector: 'vex-edit-stream-event',
  templateUrl: './edit-stream-event.component.html',
  styleUrls: ['./edit-stream-event.component.scss']
})
export class EditStreamEventComponent implements OnInit {
  form: UntypedFormGroup;
  formLang: any;
  iconFormFlag: any;
  flags = {
    en: 'flag:united-states',
    it: 'flag:italy'
  };
  currentLang: string;
  event;
  categories = [
    { value: 'fitness', label: 'Fitness' },
    { value: 'fitness_generic_1', label: 'Fitness generic 1' },
    { value: 'fitness_generic_2', label: 'Fitness generic 2' },
    { value: 'mobility', label: 'Mobility' },
    { value: 'nutrition', label: 'Nutrition' },
    { value: 'pilates', label: 'Pilates' },
    { value: 'wellness_lifestyle', label: 'Q&A Benessere e stile di vita' },
    { value: 'post_partum', label: 'Post partum' },
    { value: 'pregnancy', label: 'pregnancy' },
    { value: 'recovery', label: 'Recupero' },
    { value: 'workouts', label: 'Workouts' },
    { value: 'yoga', label: 'Yoga' }
  ];
  hours;

  constructor(@Inject(MAT_DIALOG_DATA) private item: any['item'], private fb: UntypedFormBuilder, public translate: TranslateService, public guiService: GuiService, public restService: RestService, private dialogRef: MatDialogRef<StreamEventComponent>, public dialog: MatDialog) {
    this.currentLang = translate.currentLang || translate.getDefaultLang();
  }

  ngOnInit(): void {
    this.generateHours();
    this.changeFormLanguage(this.translate.currentLang);
    this.event = this.item;
    this.form = this.fb.group({
      nome_it: [null, Validators.required],
      nome_en: [null, Validators.required],
      desc_it: [null, Validators.required],
      desc_en: [null, Validators.required],
      date: [null, Validators.required],
      category: [null, Validators.required],
      hourFrom: [null, Validators.required],
      hourTo: [null, Validators.required]
    })

    this.form.controls['nome_it'].setValue(this.item.i18nTitle['IT']);
    this.form.controls['nome_en'].setValue(this.item.i18nTitle['EN']);
    this.form.controls['desc_it'].setValue(this.item.i18nDescription['IT']);
    this.form.controls['desc_en'].setValue(this.item.i18nDescription['EN']);
    this.form.controls['category'].setValue(this.item.category);
    this.form.controls['hourFrom'].setValue(this.item.hourFrom);
    this.form.controls['hourTo'].setValue(this.item.hourTo);
    this.form.controls['date'].setValue(formatDate(this.item.date, 'yyyy-MM-dd', 'en'));
  }

  changeFormLanguage(lang) {
    this.iconFormFlag = this.flags[lang];
    this.formLang = lang;
  }

  confirmClose() {
    this.dialog.open(CloseConfirmComponent, {
      disableClose: true,
      hasBackdrop: true,
      panelClass: 'close-dialog-modalbox'
    }).afterClosed().subscribe((ris) => {
      if (ris == 'true') {
        this.dialogRef.close()
      }
    })
  }

  generateHours() {
    const times = [];

    for (let h = 0; h < 24; h++) {
      for (let m = 0; m < 60; m += 15) {
        const hour = h.toString().padStart(2, '0');
        const minute = m.toString().padStart(2, '0');
        times.push(`${hour}:${minute}`);
      }
    }

    this.hours = times;
  }

  submit() {
    const data = {
      i18nTitle: {
        "EN": this.form.value.nome_en,
        "IT": this.form.value.nome_it,
      },
      i18nDescription: {
        "EN": this.form.value.desc_en,
        "IT": this.form.value.desc_it,
      },
      date: moment(this.form.value.date, "YYYY-MM-DD").format("DD/MM/YYYY"),
      category: this.form.value.category,
      hourFrom: this.form.value.hourFrom,
      hourTo: this.form.value.hourTo,
      userId: this.guiService.userLogged.user.id,
      eventId: this.event._id
    }

    console.debug(this.form.value)

    setTimeout(() => this.guiService.showSpinner = true, 0)
    this.restService.postService('node', '/update-stream-event', data).subscribe((ris) => {
      this.dialogRef.close('done');
    })
  }

}
